import { Paper, styled } from '@mui/material';

const StyledGoalsFormCreateItemWrap = styled(Paper)({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	minHeight: '260px',
	borderRadius: '20px',
	cursor: 'pointer',
	transition: 'all .3s',

	'&:hover': {
		background: '#FFF',
	},
});

export default StyledGoalsFormCreateItemWrap;
